import { HOME_COUNTERS_API } from "../../../Utilities/APIs";
import ALtNPCRUD from "../../Partials/Layouts/CRUDs/CRUDLayouts/ALtNPCRUD/ALtNPCRUD";

function HomeCounter() {
  return (
    <ALtNPCRUD
        // common props
        api={HOME_COUNTERS_API}
        screenTopicSingular='Home Counter'
        screenTopicPlural='Home Counters'
        
        // crud header props
        showTotalInHeading
        
        // crud props
        allowCreate
        allowUpdate
        allowDelete
        
        // field props
        maxPrecedence={4}

        longTextDBField='engName'
        longTextName='English Name'
    />
  )
}

export default HomeCounter